export const solutionsEnum = {
    GOHUB: "gohub",
    TCARD: "TCARD",
    TFLEET: "TFLEET",
    TTOLL: "TTOLL"   
}